import { createRoute,Outlet } from '@tanstack/react-router'

import { rootRoute } from '../root'

export const promotionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'promotions',
  component: Outlet,
})
